import React, { useEffect } from "react";
import useStorage from "../../hooks/useStorage";
import { motion } from "framer-motion";

const ProgressBar = ({ file, setFile, setUrl }) => {
  const { progress, url } = useStorage(file);

  useEffect(() => {
    if (url) {
      setFile(null);
      setUrl(url);
    }
  }, [url, setFile]);

  return (
    <motion.div
      className='progress-bar'
      style={{
        height: "5px",
        background: "#efb6b2",
        marginTop: "20px",
      }}
      initial={{ width: 0 }}
      animate={{ width: progress + "%" }}
    ></motion.div>
  );
};

export default ProgressBar;
